import {
    DIC
} from '@/const/dic'
// import {
//     validateChinese
// } from '@/util/validate'
import {
    formatterDateToUTC
} from '@/util/util'



export const promotersStatisticsOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    columnBtn: false,
    //viewBtn: true,
    menuWidth: '200',
    labelWidth: '150',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [{
            label: "推广人姓名/昵称",
            prop: "name",
            type: "input",
            search: true,
            addVisdiplay: false,
            editVisdiplay: false,
            width: "110"
        },
        {
            label: "推广人账号",
            prop: "account",
            type: "input",
            search: true,
            addVisdiplay: false,
            editVisdiplay: false,
            width: "110"
        },
        {
            label: "推广人用户类型",
            prop: "clientType",
            type: "select",
            search: true,
            dicData: DIC.TAGS_CLIENT_TYPE,
            addVisdiplay: false,
            editVisdiplay: false,
            width: "110"
        },
        {
            label: "分组标签",
            prop: "labelName",
            span: 13,
            width: '250',
            type: 'select',
            formsolt: true,
            solt: true,
        },
        {
            label: "分销销量",
            prop: "number",
            type: 'input',
            span: 18
        },
        {
            label: "分销佣金(含待结算)",
            prop: "money",
            type: 'input',
            span: 18
        },
        {
            label: "最近一单成功时间",
            prop: "startDate_endDate",
            type: "datetimerange",
            valueFormat: "timestamp",
            span: 24,
            search: true,
            hide: true,
            clearable: true,
            formatter: function (row, value, label, column) {
                return formatterDateToUTC(row.startTime) + '至' + formatterDateToUTC(row.endTime)
            }
        },
        {
            label: "最近一单成功时间",
            prop: "payTime",
            type: "datetime",
            // sortable: true,
            valueFormat: "timestamp",
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false
        },
    ]
};